<template>
  <div>
    <div class="added-to-cart__product-visual">
      <AppLink :to="item.url">
        <img
          :src="image"
          :alt="item.name"
        >
      </AppLink>
    </div>
    <div class="added-to-cart__product-info">
      <div class="product-info">
        <div class="product-info__content">
          <div class="product-info__brand">
            {{ item.brand?.label }}
          </div>
          <b class="product-info__name">
            {{ item.name }}
          </b>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { EsProduct } from '~/nuxt3-base/app/types/elastic'

export interface Props {
  item: EsProduct
}

const { public: config } = useRuntimeConfig()
const props = defineProps<Props>()

const image = computed<string>(() => {
  return props.item.image || `${config.xcdnUrl}media/catalog/product/placeholder/default/Product.FallBack.jpg`
})
</script>
